
export const roundSize = (s) => ({
    width : Math.round(s.width ),
    height: Math.round(s.height),
});

